<template>
    <div class="row">
      <div class="text-center col-12 p-5 ">
        <h2>404 Error - Not Found</h2>
        <p>指定されたページ（URL）は見つかりません。</p>
      </div>
    </div>
</template>


<style scoped>
</style>

<script>
    export default {
        data () {
            return {
            };
        },
        mounted () {
          this.$root.$refs.loading.$data.show = false
        },
        methods: {
        },
        filters: {
        }
    };
</script>


// WEBPACK FOOTER //
// src/assets/js/components/404.vue